import "flickity-imagesloaded";
import Flickity from "flickity";
import "flickity/css/flickity.css";

(() => {
  const galleries = Array.from(document.querySelectorAll("[data-gallery]"));

  const initGallery = (gallery) => {
    const flkty = new Flickity(gallery, {
      freeScroll: false,
      contain: true,
      imagesLoaded: true,
      prevNextButtons: true,
      pageDots: true,
      wrapAround: false,
      cellAlign: "left",
      groupCells: true,
    });

    const layout = () => {
      const imgs = Array.from(gallery.querySelectorAll("img"));

      imgs.forEach((img) => {
        const imgSlideParent = img.closest(".gallery__slide");

        if (imgSlideParent) {
          imgSlideParent.style.width = `${img.getBoundingClientRect().width}px`;
        }
      });

      flkty.reloadCells();
      flkty.resize();
    };

    window.onload = () => {
      layout();
    };

    window.onresize = () => {
      layout();
    };

    flkty.on("settle", () => {
      layout();
    });

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting === true) {
          layout();

          io.unobserve(gallery);
        }
      });
    });

    io.observe(gallery);

    const images = document.querySelectorAll(".image__carousel");
    const lightbox = new window.FsLightbox();

    lightbox.props.sources = Array.from(images).map((image) => image.src);

    const fullScreenButtons = document.querySelectorAll(".image__fullscreen");

    fullScreenButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const index = Array.from(fullScreenButtons).indexOf(button);

        lightbox.open(index);
      });
    });
  };

  galleries.forEach((gallery) => initGallery(gallery));
})();
